module.exports = __webpack_public_path__ + "static/img/tu2.a4d67e5c.png";